module.exports = __webpack_public_path__ + "assets/img/self-serve.6ebe1c7f.svg";